import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { makeAjax, respStatus, showMessage, url } from "../../helpers/global_helper";
import { iconData } from "./SideBarMenu";
import PromoIcon from "../../../src/assets/images/sidebar/promo.svg";
import NewIcon from "../../../src/assets/images/sidebar/new.svg";
import HotTagIcon from "../../../src/assets/images/sidebar/hot.svg";
import FestiveThemeImg from "../../assets/images/FestiveTheme/all-game-ice.svg";
import NewYearThemeImg from "../../assets/images/FestiveTheme/theme2/Desktop/active_left_menu.svg";
import { useSelector } from "react-redux";
import CoachMarkPopup from "../Modal/CoachMarkPopup";

const gameCodesSequence = ["AllGames", "WH", "48D", "36D", "24D", "12D", "SB", "DT", "PD", "MB", "ARCADE"];

const SideBarSection = (props) => {
  const [gameData, setGameData] = useState([]);
  const currentStep = useSelector((state) => state.paginationData.currentStep)
  const navigate = useNavigate(); // Initialize useNavigate
  const [visbleValue, setVisbleValue] = useState("");
  const [scrollTarget, setScrollTarget] = useState(null);
  const [FestiveThem, setFestiveThem] = useState(2);
  let gameActiveCount = -1;

  const [activeState, setActiveState] = useState(
    window.location.pathname === "/" ? "AllGames" : localStorage.getItem('activeState')
  );

  const device = useSelector(state => state.CommonConfig.device_type);


  useEffect(() => {
  }, [device]);

  useEffect(() => {
    localStorage.setItem('activeState', activeState);
  }, [activeState]);


  const fetchGameList = () => {
    makeAjax(url.DINGDONG_API.listGame).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      let tempGameList = response.data.map(game => ({
        ...game,
        label_lobby: game.label_lobby.split(","),
        is_new: game.label_lobby.includes("new"),
        is_promo: game.label_lobby.includes("promo"),
        is_hot: game.label_lobby.includes("hot")
      }));
      let gameList = [];
      gameList.push({
        game_code: 'AllGames',
        game_name: 'Dingdong All Games',
        label_lobby: [],
        is_new: false,
        is_promo: false,
        is_hot: false
      });
      gameList = [...gameList, ...tempGameList];
      gameList.push({
        game_code: 'MB',
        game_name: 'Dingdong Multi Bet',
        label_lobby: [],
        is_new: false,
        is_promo: false,
        is_hot: false
      });
      
      // gameList.push({
      //   game_code: 'ARCADE',
      //   game_name: 'Arcade',
      //   label_lobby: [],
      //   is_new: false,
      //   is_promo: false,
      //   is_hot: false
      // });

      // const missingGames = gameCodesSequence.filter(code => !gameList.find(game => game.game_code === code));
      // const additionalGames = missingGames.map(code => ({
      //   game_code: code,
      //   label_lobby: [],
      //   is_new: false,
      //   is_promo: false,
      //   is_hot: false
      // }));
      setGameData(gameList);
      // setGameData([...gameList, ...additionalGames]);
    });
  };

  useEffect(() => {
    fetchGameList();
  }, [activeState]);

  const isConditionMet = currentStep === 6 || currentStep === 7;

  const multiBetRef = useRef();

  useEffect(() => {
    if (currentStep === 11 && device === "Desktop") {
      setActiveState("MB")
    }
  }, [])

  useEffect(() => {
    if ((currentStep === 11 || currentStep === 12) && device === "Desktop") {
      setActiveState("MB");
      navigate("/game/MB");
      setScrollTarget(multiBetRef.current)

      if (multiBetRef.current) {
        multiBetRef.current.style.overflow = 'visible';

        setTimeout(() => {
          multiBetRef.current.scrollIntoView({
            behavior: "auto",
            block: "start"
          });
        }, 0)
      }
    } else if (currentStep < 11) {
      setActiveState("AllGames");
      navigate("/game/AllGames");
    }
  }, [currentStep]);


  return (
    <div className={`sidebar ${device === "Desktop" ? "desktop" : "mobile"}`} style={{
      zIndex: currentStep === 11
        ? 1
        : isConditionMet
          ? 1
          : scrollTarget === multiBetRef.current
            ? 0
            : "auto",
      overflow:
        isConditionMet
          ? "visible"
          : scrollTarget === multiBetRef.current
            ? "auto"
            : undefined
    }} ref={multiBetRef}>
      <div className="left_section">
        <ul>
          {gameCodesSequence.map((gameCode, index) => {
            const item = gameData.find(game => game.game_code === gameCode);
            if (!item) return null;
            gameActiveCount++;
            return (
              <li key={index} className={`left-game custom-tooltip-wrapper ${activeState === gameCode ? "active" : ""}
               ${(currentStep === 6 && index === 0) && "highlighted all-game"} ${(currentStep === 7 && (index === 1 || index === 2 || index === 3 || index === 4 || index === 5 || index === 6 || index === 7 || index === 8)) && "highlighted fourdgame"}  ${(currentStep === 11 && index === 9) && "highlighted multi-bet"} `}
                onClick={() => setActiveState(gameCode)} {...((currentStep === 11 && index === 9) && { ref: multiBetRef })}>

                <div>
                  <Link to={`/game/${item.game_code}`} >
                    <React.Fragment>
                      <div className="sidebar_menu_logo">
                        <img src={iconData[item.game_code]} alt={item.game_code} />
                      </div>
                      {/* <p>{props.t(item.game_code + "_label")}</p> */}
                      {/* <p>{props.t(item.game_code + "_label", { defaultValue: item.game_code === "AllGames" ? "All Games" : item.game_name.replace("Dingdong", "") })}</p> */}
                      <p>
                        {props.t(item.game_code + "_label", {
                          defaultValue:
                            item.game_code === "AllGames"
                              ? "All Games"
                              : item.game_code === "ARCADE"
                                ? "Arcade"
                                : item.game_name.replace("Dingdong", "").trim()
                        })}
                      </p>
                      {item.is_promo && <div className="sidebar_tag"><img className="blink_img" src={PromoIcon} alt="" /></div>}
                      {item.is_new && <div className="sidebar_tag"><img className="blink_img" src={NewIcon} alt="" /></div>}
                      {item.is_hot && <div className="sidebar_tag"><img className="blink_img" src={HotTagIcon} alt="" /></div>}
                    </React.Fragment>
                  </Link>
                  {currentStep == 6 && index == 0 && <CoachMarkPopup />}
                  {currentStep == 7 && gameActiveCount == 1 && <CoachMarkPopup />}
                

                </div>
                {
                  activeState === gameCode && FestiveThem === 1 && (<div className="festiveTheme-sidebar-highlight">
                    <img src={FestiveThemeImg} alt="" />
                  </div>)
                }
                {
                  activeState === gameCode && FestiveThem === 2 && (<div className="NewYearTheme-sidebar-highlight">
                    <img src={NewYearThemeImg} alt="" />
                  </div>)
                }
              </li>
            );
            <>

            </>
          })}

        </ul>

        {currentStep === 6 && <div className="custom-overlay" style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}></div>}
        {currentStep === 7 && <div className="custom-overlay" style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}></div>}
        {currentStep === 7 && <div className="custom-overlay" style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}></div>}
        {currentStep === 7 && <div className="custom-overlay" style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}></div>}
        {currentStep === 7 && <div className="custom-overlay" style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}></div>}
        {currentStep === 11 && <div className="custom-overlay multibetClass" style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}></div>}

      </div>
      {currentStep === 9 && <div className="custom-overlay" style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}></div>}

      {currentStep === 10 && <div className="custom-overlay" style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}></div>}

    </div>
  );
};

export default withTranslation()(SideBarSection);
